/* import { useTranslation } from "react-i18next"; */
import styled from "styled-components";
import { PageStyles } from "../../layout/Page.styles";
import AdminHomeScreen from "./WelcomeHomeScreen";

const { Body: OriginalBody } = PageStyles;

const StyledBody = styled(OriginalBody)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HomeScreen = () => {
  /* const { t } = useTranslation(undefined, { keyPrefix: "screen.home" }); */

  return (
    <>
      {/* <Header>
        <Title>{t("title")}</Title>
      </Header> */}
      <StyledBody>
        <AdminHomeScreen />
      </StyledBody>
    </>
  );
};

export default HomeScreen;
